import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = signed in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tok = localStorage.getItem("c7_token");
    if (!tok) {
      setUser(false);
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("c7_token"); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password, force = false) {
    const { data } = await api.post("/auth/login", { email, password, force });
    localStorage.setItem("c7_token", data.token);
    setUser(data.user);
    return data; // {token, user, landing_path}
  }

  async function logout() {
    // Hit the backend FIRST so the agent_login_sessions row is closed and
    // active_session_id is cleared — this immediately removes the agent from
    // the realtime Live Dashboard (floor membership is keyed on the open login
    // session). Best-effort: never block the redirect on a network hiccup.
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore — token may already be invalid */
    }
    localStorage.removeItem("c7_token");
    setUser(false);
    window.location.href = "/login";
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
